import React, { useState, useEffect } from "react";
import Navbar from "./navbar";
import TopNavbar from "./topnavbar";
import Footer from "./footer";
import { useNavigate, useLocation } from "react-router-dom";
import "../App.css";
import * as XLSX from "xlsx";
import axios from "axios";


const Reports = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [refreshKey, setRefreshKey] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState("All");
  const [selectedEmpStatus, setSelectedEmpStatus] = useState("All");
  const [selectedEmploymentStatus, setSelectedEmploymentStatus] = useState("All");
  const [selectedDepartment, setSelectedDepartment] = useState("All");
  const [selectedPosition, setSelectedPosition] = useState("All");
  const [selectedHiredMonth, setSelectedHiredMonth] = useState("All");
  const [selectedHiredYear, setSelectedHiredYear] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);  
  const employeesPerPage = 10; 

  const handleUpdate = (EmployeeId) => {
    navigate(`/update/${EmployeeId}`);
  };

//   const handleFacilityFilterChange = (event) => {
//     const { value } = event.target;
//     setSelectedFacility(value);
//     if (value === "All") {
//       setFilteredEmployees(employees);
//     } else {
//       const filtered = employees.filter(
//         (employee) => employee.Facility === value
//       );
//       setFilteredEmployees(filtered);
//     }
//   };

//   const handleEmpStatusFilterChange = (event) => {
//     const { value } = event.target;
//     setSelectedEmpStatus(value);
//     if (value === "All") {
//       setFilteredEmployees(employees);
//     } else {
//       const filtered = employees.filter(
//         (employee) => employee.EmployeeStatus === value
//       );
//       setFilteredEmployees(filtered);
//     }
//   };

//   const handleSearchChange = (event) => {
//   const { value } = event.target;
//   setSearchQuery(value);
//   setCurrentPage(1); 
//   filterEmployees(value);
// };

//   const filterEmployees = (query) => {
//     const filtered = employees.filter(
//       (employee) =>
//         String(employee.EmployeeId)
//           .toLowerCase()
//           .includes(query.toLowerCase()) ||
//         employee.EmployeeName.toLowerCase().includes(query.toLowerCase())
//     );
//     setFilteredEmployees(filtered);
//   };


  const applyFilters = ({
    query = searchQuery,
    facility = selectedFacility,
    empStatus = selectedEmpStatus,
    employmentStatus = selectedEmploymentStatus,
    department = selectedDepartment,
    position = selectedPosition,
    hiredMonth = selectedHiredMonth,
    hiredYear = selectedHiredYear,
  }) => {
    let filtered = employees;

    if (query.trim() !== "") {
      filtered = filtered.filter(
        (employee) =>
          String(employee.EmployeeId).toLowerCase().includes(query.toLowerCase()) ||
          employee.EmployeeName.toLowerCase().includes(query.toLowerCase())
      );
    }

    if (facility !== "All") {
      filtered = filtered.filter((employee) => employee.Facility === facility);
    }

    if (empStatus !== "All") {
      filtered = filtered.filter((employee) => employee.EmployeeStatus === empStatus);
    }

    if (employmentStatus !== "All") {
      filtered = filtered.filter((employee) => employee.EmploymentStatus === employmentStatus);
    }

    if (department !== "All") {
      filtered = filtered.filter((employee) => employee.DepartmentName === department);
    }

    if (position !== "All") {
      filtered = filtered.filter((employee) => employee.Position === position);
    }

    if (hiredMonth !== "All") {
      filtered = filtered.filter((employee) => {
        if (!employee.DateHired) return false;
        return new Date(employee.DateHired).getMonth() + 1 === Number(hiredMonth);
      });
    }

    if (hiredYear !== "All") {
      filtered = filtered.filter((employee) => {
        if (!employee.DateHired) return false;
        return new Date(employee.DateHired).getFullYear().toString() === hiredYear;
      });
    }

    setFilteredEmployees(filtered);
    setCurrentPage(1);
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
    applyFilters({ query: value });
  };

  const handleClearFilters = () => {
    setSearchQuery("");
    setSelectedFacility("All");
    setSelectedEmpStatus("All");
    setSelectedEmploymentStatus("All");
    setSelectedDepartment("All");
    setSelectedPosition("All");
    setSelectedHiredMonth("All");
    setSelectedHiredYear("All");
    setFilteredEmployees(employees);
    setCurrentPage(1);
  };

  useEffect(() => {
  if (location.state?.refreshed) {
    setRefreshKey(prev => prev + 1); // ← increments counter, triggers data refetch
  }
}, [location.state]);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch("/api/retrieveReports");
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        function convertToTitleCase(str) {
          if (typeof str === "string" && str !== null && str.trim() !== "") {
            return str.toLowerCase().replace(/\b\w/g, function (char) {
              return char.toUpperCase();
            });
          } else {
            return "";
          }
        }

        const formattedData = data.map((employee) => ({
          ...employee,
          EmployeeName: convertToTitleCase(employee.EmployeeName),
          EmployeeStatus: convertToTitleCase(employee.EmployeeStatus),
          EmploymentStatus: convertToTitleCase(employee.EmploymentStatus),
        }));

        setEmployees(formattedData);
        setFilteredEmployees(formattedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchData();
}, [refreshKey]);

  const getStatusColor = (status) => {
    switch (status) {
      case "Active":
        return "text-success";
      case "Separated":
        return "text-danger";
      case "Inactive - Maternity":
      case "Inactive - Sickness":
        return "text-primary";
      case "Inactive - Absent Without Leave":
        return "text-danger";
      case "Inactive - Absent With Leave":
        return "text-info";
      case "Inactive - Suspension":
        return "text-warning";
      default:
        return "";
    }
  };
  //this only download data that are visible in the user interface table
  // const handleDownloadExcel = () => {
  //   const ws = XLSX.utils.json_to_sheet(filteredEmployees);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Employees Data Report");

  //   XLSX.writeFile(wb, "Employees_Report.xlsx");
  // };

  // Helper function to convert text to title case
  const toTitleCase = (text) => {
    return text
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  //this downloads all the employee data in multiple tables
// const handleDownloadExcel = async () => {
//   try {
//     // Fetch data from the backend
//     const response = await axios.get("/api/getAllEmployees");

//     if (response.status !== 200) {
//       throw new Error("Failed to fetch data");
//     }

//     const data = response.data;

//     // Log the response data to inspect
//     // Specify fields to exclude
//     const excludedFields = [
//       "EmpInfoID",
//       "ProjectId",
//       "DepartmentId",
//       "ProdId",
//       "ShiftId",
//       "EducationID",
//       "AddressID",
//       "ContactId",
//       "ShiftID",
//       "DependentID",
//       "CreatedAt",
//     ];

//     // Extract headers (field names) dynamically from the first row of data
//     const headers = Object.keys(data[0]).filter(
//       (field) => !excludedFields.includes(field)
//     );

//     // Format date fields and other specific fields
//     const formattedData = data.map((row) => {
//       const formattedRow = {};
//       headers.forEach((field) => {
//         if (
//           [
//             "FirstName",
//             "LastName",
//             "MiddleName",
//             "MaidenName",
//             "EmployeeName",
//             "DUName",
//             "DepartmentName",
//             "ManagerName",
//             "PMPICIDName",
//             "EmploymentStatus",
//           ].includes(field)
//         ) {
//           formattedRow[field] = row[field] ? toTitleCase(row[field]) : "";
//         } else if (
//           field === "Birthdate" ||
//           field === "DateHired" ||
//           field === "DateTo" ||
//           field === "DateFrom" ||
//           field === "DateOfBirth"
//         ) {
//           formattedRow[field] = row[field]
//             ? new Date(row[field]).toLocaleDateString()
//             : "";
//         } else if (typeof row[field] === "boolean") {
//           // Convert boolean to 1 or 0
//           formattedRow[field] = row[field] ? 1 : 0;
//         } else if (
//           field === "IsActive" ||
//           field === "IsPermanent" ||
//           field === "IsEmergency"
//         ) {
//           // Handle specific boolean fields
//           formattedRow[field] = row[field] ? 1 : 0;
//         } else if (field === "EmployeeId") {
//           // Ensure array fields are joined properly
//           formattedRow[field] = Array.isArray(row[field])
//             ? row[field][0]
//             : row[field];
//         } else {
//           formattedRow[field] = row[field];
//         }
//       });
//       return formattedRow;
//     });

//     // Create a worksheet from the formatted data
//     const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

//     // Auto-adjust column widths based on the longest cell value in each column
//     const maxLengths = headers.map((header) =>
//       Math.max(
//         ...formattedData.map((row) =>
//           row[header] ? row[header].toString().length : 0
//         ),
//         header.length
//       )
//     );
//     ws["!cols"] = maxLengths.map((length) => ({ width: length + 2 }));

//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Employees Data Report");

//     // Write the workbook to a file
//     XLSX.writeFile(wb, "Employees_Report.xlsx");
//     alert("File has been successfully downloaded!");
//   } catch (error) {
//     console.error("Error occurred while downloading data:", error);
//     alert("Failed to download data. Please try again.");
//   }
// };
const handleDownloadExcel = async () => {
  try {
    if (filteredEmployees.length === 0) {
      alert("No data to download.");
      return;
    }

    const excludedFields = [
      "EmpInfoID", "ProjectId", "DepartmentId", "ProdId", "ShiftId",
      "EducationID", "AddressID", "ContactId", "ShiftID", "DependentID", "CreatedAt",
    ];

    const headers = Object.keys(filteredEmployees[0]).filter(
      (field) => !excludedFields.includes(field)
    );

    const formattedData = filteredEmployees.map((row) => {
      const formattedRow = {};
      headers.forEach((field) => {
        if (["FirstName","LastName","MiddleName","MaidenName","EmployeeName",
             "DUName","DepartmentName","ManagerName","PMPICIDName","EmploymentStatus"].includes(field)) {
          formattedRow[field] = row[field] ? toTitleCase(row[field]) : "";
        } else if (["Birthdate","DateHired","DateTo","DateFrom","DateOfBirth"].includes(field)) {
          formattedRow[field] = row[field] ? new Date(row[field]).toLocaleDateString() : "";
        } else if (["IsActive","IsPermanent","IsEmergency"].includes(field)) {
          formattedRow[field] = row[field] ? 1 : 0;
        } else if (field === "EmployeeId") {
          formattedRow[field] = Array.isArray(row[field]) ? row[field][0] : row[field];
        } else {
          formattedRow[field] = row[field];
        }
      });
      return formattedRow;
    });

    const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

    const maxLengths = headers.map((header) =>
      Math.max(...formattedData.map((row) => row[header]?.toString().length || 0), header.length)
    );
    ws["!cols"] = maxLengths.map((length) => ({ width: length + 2 }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Employees Data Report");
    XLSX.writeFile(wb, "Employees_Report.xlsx");
    alert("File has been successfully downloaded!");
  } catch (error) {
    console.error("Error occurred while downloading data:", error);
    alert("Failed to download data. Please try again.");
  }
};

  const indexOfLastEmployee = currentPage * employeesPerPage;
  const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;
  const currentEmployees = filteredEmployees.slice(indexOfFirstEmployee, indexOfLastEmployee);
  const totalPages = Math.ceil(filteredEmployees.length / employeesPerPage);

  return (
    <div>
      <div id="wrapper">
        <Navbar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <TopNavbar />
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-xl-12 col-lg-12">
                  {/* FILTER CONTAINER */}
                  <div className="card shadow-sm mb-3">
                    <div className="card-body py-3 px-3">

                      <div className="d-flex align-items-end flex-wrap" style={{ gap: "12px" }}>

                        {/* Search */}
                        <div className="flex-grow-1" style={{ minWidth: 200 }}>
                          <div className="d-flex align-items-center bg-light border rounded px-2" style={{ height: 38 }}>
                            <i className="fas fa-search text-muted mr-2" style={{ fontSize: 11 }}></i>
                            <input
                              type="text"
                              className="border-0 bg-transparent small"
                              style={{ outline: "none", height: "100%", width: 0, flexGrow: 1 }}
                              placeholder="Search by ID or Name"
                              value={searchQuery}
                              onChange={handleSearchChange}
                            />
                          </div>
                        </div>

                        {/* Facility */}
                        <div>
                          <div className=" text-muted mb-1" style={{ fontSize: 11, fontWeight: "bold", letterSpacing: "0.06em" }}>Facility</div>
                          <select className="form-control form-control-sm" style={{ width: 120 }} value={selectedFacility}
                            onChange={(e) => { setSelectedFacility(e.target.value); applyFilters({ facility: e.target.value }); }}>
                            <option value="All">All facilities</option>
                            {[...new Set(employees.map(e => e.Facility).filter(Boolean))].map(f => <option key={f} value={f}>{f}</option>)}
                          </select>
                        </div>

                        {/* Employee Status */}
                        <div>
                          <div className=" text-muted mb-1" style={{ fontSize: 11, fontWeight: "bold", letterSpacing: "0.06em" }}>Employee Status</div>
                          <select className="form-control form-control-sm" style={{ width: 130 }} value={selectedEmpStatus}
                            onChange={(e) => { setSelectedEmpStatus(e.target.value); applyFilters({ empStatus: e.target.value }); }}>
                            <option value="All">All status</option>
                            {[...new Set(employees.map(e => e.EmployeeStatus).filter(Boolean))].map(s => <option key={s} value={s}>{s}</option>)}
                          </select>
                        </div>

                        {/* Employment Type */}
                        <div>
                          <div className="text-muted mb-1" style={{ fontSize: 11, fontWeight: "bold", letterSpacing: "0.06em" }}>Employment Type</div>
                          <select className="form-control form-control-sm" style={{ width: 135 }} value={selectedEmploymentStatus}
                            onChange={(e) => { setSelectedEmploymentStatus(e.target.value); applyFilters({ employmentStatus: e.target.value }); }}>
                            <option value="All">All types</option>
                            {[...new Set(employees.map(e => e.EmploymentStatus).filter(Boolean))].map(s => <option key={s} value={s}>{s}</option>)}
                          </select>
                        </div>

                        {/* Department */}
                        <div>
                          <div className="text-muted mb-1" style={{ fontSize: 11, fontWeight: "bold", letterSpacing: "0.06em" }}>Department</div>
                          <select className="form-control form-control-sm" style={{ width: 135 }} value={selectedDepartment}
                            onChange={(e) => { setSelectedDepartment(e.target.value); applyFilters({ department: e.target.value }); }}>
                            <option value="All">All departments</option>
                            {[...new Set(employees.map(e => e.DepartmentName).filter(Boolean))].map(d => <option key={d} value={d}>{d}</option>)}
                          </select>
                        </div>

                        {/* Position */}
                        <div>
                          <div className="text-muted mb-1" style={{ fontSize: 11, fontWeight: "bold", letterSpacing: "0.06em" }}>Position</div>
                          <select className="form-control form-control-sm" style={{ width: 120 }} value={selectedPosition}
                            onChange={(e) => { setSelectedPosition(e.target.value); applyFilters({ position: e.target.value }); }}>
                            <option value="All">All positions</option>
                            {[...new Set(employees.map(e => e.Position).filter(Boolean))].map(p => <option key={p} value={p}>{p}</option>)}
                          </select>
                        </div>

                        {/* Hired Month */}
                        <div>
                          <div className="text-muted mb-1" style={{ fontSize: 11, fontWeight: "bold", letterSpacing: "0.06em" }}>Hired Month</div>
                          <select className="form-control form-control-sm" style={{ width: 110 }} value={selectedHiredMonth}
                            onChange={(e) => { setSelectedHiredMonth(e.target.value); applyFilters({ hiredMonth: e.target.value }); }}>
                            <option value="All">All months</option>
                            {["January","February","March","April","May","June","July","August","September","October","November","December"].map((m, i) => (
                              <option key={m} value={i + 1}>{m}</option>
                            ))}
                          </select>
                        </div>

                        {/* Hired Year */}
                        <div>
                          <div
                            className="text-muted mb-1"
                            style={{ fontSize: 11, fontWeight: "bold", letterSpacing: "0.06em" }}
                          >
                            Hired Year
                          </div>

                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="YYYY"
                            maxLength="4"
                            style={{ width: 90 }}
                            value={selectedHiredYear === "All" ? "" : selectedHiredYear}
                            onChange={(e) => {
                              setSelectedHiredYear(e.target.value);
                              applyFilters({ hiredYear: e.target.value || "All" });
                            }}
                          />
                       </div>

                        {/* Clear */}
                        <button className="btn btn-sm btn-secondary" style={{ height: 31 }} onClick={handleClearFilters}>
                          Clear Filters
                        </button>

                      </div>

                      {/* Active pills */}
                      {(() => {
                        const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
                        const pills = [
                          searchQuery                        && { key: "search",    label: `Search: ${searchQuery}`,                onRemove: () => handleSearchChange({ target: { value: "" } }) },
                          selectedFacility !== "All"         && { key: "facility",  label: `Facility: ${selectedFacility}`,         onRemove: () => { setSelectedFacility("All"); applyFilters({ facility: "All" }); } },
                          selectedEmpStatus !== "All"        && { key: "empStatus", label: `Status: ${selectedEmpStatus}`,          onRemove: () => { setSelectedEmpStatus("All"); applyFilters({ empStatus: "All" }); } },
                          selectedEmploymentStatus !== "All" && { key: "empType",   label: `Type: ${selectedEmploymentStatus}`,     onRemove: () => { setSelectedEmploymentStatus("All"); applyFilters({ employmentStatus: "All" }); } },
                          selectedDepartment !== "All"       && { key: "dept",      label: `Dept: ${selectedDepartment}`,           onRemove: () => { setSelectedDepartment("All"); applyFilters({ department: "All" }); } },
                          selectedPosition !== "All"         && { key: "pos",       label: `Position: ${selectedPosition}`,         onRemove: () => { setSelectedPosition("All"); applyFilters({ position: "All" }); } },
                          selectedHiredMonth !== "All"       && { key: "month",     label: `Month: ${MONTHS[selectedHiredMonth-1]}`, onRemove: () => { setSelectedHiredMonth("All"); applyFilters({ hiredMonth: "All" }); } },
                          selectedHiredYear !== "All"        && { key: "year",      label: `Year: ${selectedHiredYear}`,            onRemove: () => { setSelectedHiredYear("All"); applyFilters({ hiredYear: "All" }); } },
                        ].filter(Boolean);
                        if (!pills.length) return null;
                        return (
                          <div className="d-flex align-items-center flex-wrap mt-2" style={{ gap: 6 }}>
                            {pills.map(p => (
                              <span key={p.key} className="badge d-inline-flex align-items-center" style={{ background: "#eff2ff", color: "#3d52d5", border: "1px solid #c7d2fe", fontWeight: 500, fontSize: 11, padding: "3px 6px 3px 8px", borderRadius: 4 }}>
                                {p.label}
                                <button onClick={p.onRemove} style={{ background: "none", border: "none", padding: 0, marginLeft: 4, cursor: "pointer", color: "#3d52d5", opacity: 0.6, lineHeight: 1 }}>✕</button>
                              </span>
                            ))}
                            <span className="text-muted" style={{ fontSize: 11 }}>{pills.length} active filter{pills.length > 1 ? "s" : ""}</span>
                          </div>
                        );
                      })()}

                    </div>
                  </div>
                  <div className="card shadow mb-4">
                    <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                      <h5 className="m-0 font-weight-bold text-primary">
                        Reports
                      </h5>
                      {/* <form className="form-inline ml-auto">
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <button className="btn btn-primary" type="button">
                              <i className="fas fa-search fa-sm"></i>
                            </button>
                          </div>
                          <input
                            type="text"
                            className="form-control bg-light border-0 small"
                            placeholder="Search by ID or Name"
                            value={searchQuery}
                            onChange={handleSearchChange}
                          />
                        </div>
                      </form> */}
                      <button
                        className="btn btn-primary ml-2"
                        onClick={handleDownloadExcel}
                      >
                        <i className="fas fa-arrow-down"></i> Employee Reports
                      </button>
                    </div>
                    <div className="card-body">
                      {/* <div className="d-flex">
                        <label className="mr-2" style={{ alignSelf: "center" }}>
                          Filter by:
                        </label>
                        <div className="form-group mr-2">
                          <select
                            className="form-control"
                            value={selectedFacility}
                            onChange={handleFacilityFilterChange}
                          >
                            <option value="All">All Facility</option>
                            {employees.length > 0 &&
                              [
                                ...new Set(
                                  employees.map((employee) => employee.Facility)
                                ),
                              ].map((facility, index) => (
                                <option key={index} value={facility}>
                                  {facility} Facility
                                </option>
                              ))}
                          </select>
                        </div>
                        <div className="form-group">
                          <select
                            className="form-control"
                            value={selectedEmpStatus}
                            onChange={handleEmpStatusFilterChange}
                          >
                            <option value="All">All Statuses</option>
                            {employees.length > 0 &&
                              [
                                ...new Set(
                                  employees.map(
                                    (employee) => employee.EmployeeStatus
                                  )
                                ),
                              ].map((empstatus, index) => (
                                <option key={index} value={empstatus}>
                                  {empstatus} Status
                                </option>
                              ))}
                          </select>
                        </div>
                      </div> */}
                      
                      <div className="table-responsive">
                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">Action</th>
                              <th scope="col">Employee Id</th>
                              <th scope="col">Name</th>
                              <th scope="col">Facility</th>
                              <th scope="col">Employee Status</th>
                              <th scope="col">Employment Status</th>
                              <th scope="col">Date Hired</th>
                              <th scope="col">Employee Role</th>
                              <th scope="col">Position</th>
                              <th scope="col">Level</th>
                              <th scope="col">Project Code</th>
                              <th scope="col">Delivery Unit</th>
                              <th scope="col">Department</th>
                              <th scope="col">Work Week Type</th>
                              <th scope="col">Work Arrangement</th>
                              <th scope="col">Shift</th>
                              <th scope="col">Shift Type</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentEmployees.length > 0 ? (
                               currentEmployees.map((employee) => (
                                <tr key={employee.EmployeeId}>
                                  <td>
                                    <button
                                      className="update-button btn btn-xs mr-2"
                                      onClick={() =>
                                        handleUpdate(employee.EmployeeId)
                                      }
                                    >
                                      <i className="fas fa-pencil-alt"></i>
                                    </button>
                                  </td>
                                  <td>{employee.EmployeeId}</td>
                                  <td>{employee.EmployeeName}</td>
                                  <td>{employee.Facility}</td>
                                  <td>
                                    <span
                                      className={getStatusColor(
                                        employee.EmployeeStatus
                                      )}
                                    >
                                      {employee.EmployeeStatus}
                                    </span>
                                  </td>
                                  <td>{employee.EmploymentStatus}</td>
                                  <td>
                                    {employee.DateHired
                                      ? new Date(
                                          employee.DateHired
                                        ).toLocaleDateString()
                                      : "N/A"}
                                  </td>
                                  <td>{employee.EmployeeRole}</td>
                                  <td>{employee.Position}</td>
                                  <td>{employee.Level}</td>
                                  <td>{employee.ProjectCode}</td>
                                  <td>{employee.DepartmentName}</td>
                                  <td>{employee.DUName}</td>
                                  <td>{employee.WorkWeekType}</td>
                                  <td>{employee.WorkArrangement}</td>
                                  <td>
                                    {employee.ShiftCode +
                                      " " +
                                      employee.ShiftName}
                                  </td>
                                  <td>{employee.ShiftType}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="20">No data available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* Pagination Controls */}
                      <div className="d-flex justify-content-between align-items-center mt-3">
                        
                        {/* Shows "Showing 1-10 of 50 employees" */}
                        <small className="text-muted">
                          Showing {indexOfFirstEmployee + 1}–{Math.min(indexOfLastEmployee, filteredEmployees.length)} of {filteredEmployees.length} employees
                        </small>

                        {/* Page buttons */}
                        <ul className="pagination mb-0">
                          
                          {/* Previous button */}
                          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                            <button
                              className="page-link"
                              onClick={() => setCurrentPage(prev => prev - 1)}
                              disabled={currentPage === 1}
                            >
                              &laquo; Prev
                            </button>
                          </li>

                          {/* Page number buttons — only shows 5 pages at a time */}
                          {Array.from({ length: totalPages }, (_, i) => i + 1)
                            .filter(page =>
                              page === 1 ||
                              page === totalPages ||
                              Math.abs(page - currentPage) <= 2
                            )
                            .reduce((acc, page, idx, arr) => {
                              if (idx > 0 && page - arr[idx - 1] > 1) {
                                acc.push('...');
                              }
                              acc.push(page);
                              return acc;
                            }, [])
                            .map((item, idx) =>
                              item === '...' ? (
                                <li key={`ellipsis-${idx}`} className="page-item disabled">
                                  <span className="page-link">...</span>
                                </li>
                              ) : (
                                <li key={item} className={`page-item ${currentPage === item ? "active" : ""}`}>
                                  <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(item)}
                                  >
                                    {item}
                                  </button>
                                </li>
                              )
                            )}

                          {/* Next button */}
                          <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                            <button
                              className="page-link"
                              onClick={() => setCurrentPage(prev => prev + 1)}
                              disabled={currentPage === totalPages}
                            >
                              Next &raquo;
                            </button>
                          </li>

                        </ul>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Reports;